<template>
  <v-app-bar clipped-left app color="primary" dark>
    <v-toolbar-title style="width: 400px" class="ml-0">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <span class="hidden-sm-and-down">Mobil Uygulama Yönetim Paneli</span>
    </v-toolbar-title>

    <v-spacer />
    <v-btn
      text
      icon
      @click="$store.dispatch('app/setDark', !$store.state.app.dark)"
    >
      <v-icon>{{ dark ? "brightness_4" : "brightness_6" }}</v-icon>
    </v-btn>
    <v-spacer />

    <span class="mx-2">{{ username }}</span>
    <language-button />
    <v-btn icon @click="signOut">
      <v-icon> power_settings_new </v-icon>
    </v-btn>
  </v-app-bar>
</template>
<script>
import LanguageButton from "../AppBar/LanguageButton";
import { mapActions, mapGetters } from "vuex";

export default {
  components: { LanguageButton },
  props: {
    drawer: Boolean,
  },
  data() {
    return {
      //dark: null,
    };
  },
  watch: {
    drawer() {
      this.$emit("update:drawer", this.drawer);
    }
  },
  computed: {
    realm() {
      const realm = this.$store.getters["auth/realm"];
      return realm;
    },
    refreshToken() {
      const refreshToken = this.$store.getters["auth/refreshToken"];
      return refreshToken;
    },
    username() {
      const jwt = this.$store.getters["auth/jwtDecoded"];
      console.log("usernameeeee", jwt);
      return jwt ? jwt.name : null;
    },
  },
  methods: {
    async signOut() {
      await this.$store.dispatch("auth/logout", {
        realm: this.realm,
        refreshToken: this.refreshToken,
      });
      this.$router.push('/'+ this.realm +'/login');
    },
  },
};
</script>